// eslint-disable-next-line no-restricted-imports -- This file is the Kobo wrapper for the component
import { Menu as MenuMantine } from '@mantine/core'
import type { MenuProps as MenuPropsMantine } from '@mantine/core'

export type MenuProps = MenuPropsMantine

export default MenuMantine
